<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-19 10:15:07
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-10-20 10:25:50
 * @Description: file content
 -->
<template>
  <div class="btn_home">
    <img @click="clickBack" :src="btnImgUrl" alt />
  </div>
</template>

<script>
/**
 * 参数
 * :url
 * 事件
 * v-on:clickMy
 */
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import wx from "weixin-js-sdk";
export default {
  components: {},
  props: {
    url: String
  },
  data() {
    return {
      btnImgUrl: ""
    };
  },
  watch: {},
  computed: {
    ...mapState(["isInMiniProgram"])
  },
  methods: {
    clickBack() {
      if(this.$route.query.backStudioUrl) {
        window.location.href = decodeURIComponent(this.$route.query.backStudioUrl)
      } else if (this.url) {
        util.openYqRsMakeLink(this.url);
      } else if (this.$listeners.clickMy) {
        this.$emit("clickMy");
      } else {
        // 如果是华发的环境，且在小程序环境下，用小程序的返回
        if (this.isInMiniProgram && util.checkIsHuafa()) {
          wx.miniProgram.navigateBack({
            delta: 1
          });
        } else {
          window.history.go(-1);
        }
      }
    }
  },
  created() {
    if (util.checkIsHuafa()) {
      this.btnImgUrl =
        "https://assets.rurushishi.com/yq-rs-make/t7_map/btn_back.png?x-oss-process=image/resize,h_100,w_100";
    } else if (util.checkIsZd()) {
      this.btnImgUrl =
        "https://assets.rurushishi.com/yq-rs-make/zhongdian/icon_back2.png?x-oss-process=image/resize,h_100,w_100";
    } else {
      this.btnImgUrl =
        "https://assets.rurushishi.com/yq-rs-make/t7_map/btn_back.png?x-oss-process=image/resize,h_100,w_100";
    }
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.btn_home img {
  width: 60px;
  height: 60px;
  position: fixed;
  right: 10px;
  bottom: 100px;
  opacity: 0.8;
  z-index: 10;
}
</style>